import api from './api';

export interface Notification {
  id: string;
  user_id: string;
  project_id: string | null;
  type: 'info' | 'success' | 'warning' | 'error' | 'campaign' | 'lead' | 'report';
  title: string;
  message: string;
  link: string | null;
  read: boolean;
  created_at: string;
  updated_at: string;
}

export const notificationService = {
  async getNotifications(params?: { page?: number; limit?: number; status?: string }) {
    const response = await api.get('/notifications', { params });
    return response.data;
  },

  async getUnreadCount() {
    const response = await api.get('/notifications/unread-count');
    return response.data;
  },

  async markAsRead(id: string) {
    const response = await api.put(`/notifications/${id}/read`);
    return response.data;
  },

  async markAllAsRead() {
    const response = await api.put('/notifications/read-all');
    return response.data;
  },

  async deleteNotification(id: string) {
    const response = await api.delete(`/notifications/${id}`);
    return response.data;
  }
};
